import { CharacterCardVariant } from "@next-platform/client-common-spicy-ui";
import { CHARACTER_MODERATION_STATUS, CHARACTER_VISIBILITY } from "@next-platform/client-common-core";

export const colWidth = 160;
export const colGap = 12;

export const CHARACTER_CARD_VARIANT = {
  [CHARACTER_MODERATION_STATUS.PENDING]: CharacterCardVariant.REVIEW,
  [CHARACTER_MODERATION_STATUS.MANUAL_REVIEW_REQUIRED]: CharacterCardVariant.UNDER_MANUAL_REVIEW,
  [CHARACTER_MODERATION_STATUS.REREVIEW_REQUIRED]: CharacterCardVariant.REVIEW,
  [CHARACTER_MODERATION_STATUS.FIX_REQUIRED]: CharacterCardVariant.ACTION,
  [CHARACTER_VISIBILITY.PUBLIC]: CharacterCardVariant.PUBLIC,
  [CHARACTER_VISIBILITY.PRIVATE]: CharacterCardVariant.PRIVATE,
  [CHARACTER_VISIBILITY.PERMANENTLY_PRIVATE]: CharacterCardVariant.PRIVATE,
  [CHARACTER_VISIBILITY.HIDDEN]: CharacterCardVariant.UNLISTED,
};
